// Helper functions to map API data to form and vice versa
import dayjs from 'dayjs';

import type { EventFormComplete } from '../../../forms/event/EventForm/schema.ts';
import { notEmpty } from '../../../lib/notEmpty.ts';
import { parseEventType } from '../../../mappers/incompleteEvent/apiToForm/lib/parseEventType.ts';
import type { EventApiData } from './types.ts';

export const eventApiToEventEditForm = (apiData: EventApiData): EventFormComplete => {
  const [defaultStartDate, defaultEndDate] = [
    dayjs().add(1, 'day').set('hour', 15).set('minute', 0).set('second', 0).toDate(),
    dayjs().add(1, 'day').set('hour', 16).set('minute', 0).set('second', 0).toDate(),
  ];

  return {
    name: apiData?.name ?? '',
    description: apiData?.long_description ?? {},
    websiteLink: apiData?.website_link ?? '',
    instagramLink: apiData?.instagram_link ?? '',
    tiktokLink: apiData?.tiktok_link ?? '',
    eventDetails:
      apiData?.event_details?.map((eventDetail) => eventDetail?.event_details_id?.id?.toString(10)).filter(notEmpty) ??
      [],
    tags:
      apiData?.target_audiences
        ?.map((targetAudience) => targetAudience?.target_audiences_id?.id?.toString(10))
        .filter(notEmpty) ?? [],
    image: (typeof apiData?.image === 'string' ? apiData.image : '') ?? '',
    image_original: (typeof apiData?.image_original === 'string' ? apiData.image_original : undefined) ?? undefined,
    image_crop_data: (apiData?.image_crop_data as { x: number; y: number; zoom: number } | null) ?? null,
    spotifyLink: apiData?.spotify_link ?? '',
    eventType: parseEventType(apiData?.type),
    venue: apiData?.venue?.id?.toString(10) ?? '',
    onlineLink: apiData?.online_link ?? '',
    start: apiData?.start ? dayjs(apiData?.start).toDate() : defaultStartDate,
    end: apiData?.end ? dayjs(apiData?.end).toDate() : defaultEndDate,
    ticketshopLink: apiData?.ticket_sale_url ?? '',
    category: apiData?.category?.id?.toString(10) ?? '',
    customVenue: ((apiData as unknown as Record<string, unknown>)?.custom_venue as string) ?? '',
  };
};
